import angular from 'angular';
import toolbarService from "../../../../Toolbar/ToolbarService";
import sectionsLibraryService from "../../../SectionsLibraryService";
import './TwitterFeed.scss';
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";
import UrlPart from "../../../../ConfigParameters/ConfigParameters/UrlPart";
import contentGuardService from "../../../../Workspace/ContentGuard/ContentGuardService";
import TwitterWidth from "../../../../ConfigParameters/ConfigParameters/TwitterWidth";
import Height from "../../../../ConfigParameters/ConfigParameters/Height";
import Language from "../../../../ConfigParameters/ConfigParameters/Language";
import Align from "../../../../ConfigParameters/ConfigParameters/Align";

const MODULE_NAME = 'pageTwitterFeed';

const creatorPageSectionTwitterFeed = {
    bindings: {
        elementModel: '=',
        uid: '<'
    },
    template: require('./twitterFeed.html'),
    controller: function (ToolbarService, ContentGuardService, $scope, $element) {

        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);
        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));

            ContentGuardService.registerLocked(MODULE_NAME);
        };

        $scope.$on('$destroy', () => {
            ContentGuardService.deregisterLocked(MODULE_NAME);
        });

        let debounce;
        $scope.$watchCollection('$ctrl.elementModel', (newParameters, oldParameters) => {
            if (newParameters['customClassName'] === oldParameters['customClassName']
                && newParameters['language'] === oldParameters['language']
                && newParameters['align'] === oldParameters['align']) {
                reloadTwitter();
            }
        });
        $scope.$watchCollection('$ctrl.elementModel.width', () => {
            reloadTwitter();
        });
        $scope.$watchCollection('$ctrl.elementModel.height', () => {
            reloadTwitter();
        });

        let reloadTwitter = () => {
            clearTimeout(debounce);
            debounce = setTimeout(() => {
                let outerElement = document.getElementById(this.elementModel.sectionId);
                outerElement.innerHTML = `<a class="twitter-timeline" id="twitter-timeline"
                                               data-width="${this.elementModel.width.value}"
                                               data-height="${this.elementModel.height.value}"
                                               data-lang="en"
                                               href="https://twitter.com/${this.elementModel.urlPart}?ref_src=twsrc%5Etfw">
                                                Tweets by ${this.elementModel.urlPart}
                                            </a>`;
                twttr.widgets.load(
                    $element[0].querySelector("#twitter-timeline")
                )
            }, 300);
        }
    }
};

export default angular.module('cms.creator.page.section-twitter-feed', [sectionsLibraryService, toolbarService, contentGuardService])
    .run(function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

        SectionsLibraryService.registerSection({
            icon: 'view_stream',
            type: MODULE_NAME,
            label: gettext('Twitter Feed'),
            group: 'page',
            options: {
                disableCopy: true
            },
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });

        let urlPart = new UrlPart();
        urlPart.setLabel(gettext('Twitter login'));
        urlPart.setDefaultValue('TwitterDev');

        let language = new Language();
        language.setOptions([{value: 'en', label: 'English'}, {value: 'pl', label: 'Polski'}]);
        language.setDefaultValue('en');

        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(new ConfigParameter('sectionId', 'hidden', gettext('Section Id'), null, (type) => UniqueIdGenerator.generate(type))),
            ...(new ConfigParameter('uid', 'hidden', '', null, () => UniqueIdGenerator.generate('element-uid'))),
            ...urlPart,
            ...language,
            ...(new Paddings()),
            ...(new Align()),
            ...(new CustomClassName()),
            ...(new TwitterWidth()),
            ...(new Height())
        });

    })
    .component('cmsCreatorPageSectionTwitterFeed', creatorPageSectionTwitterFeed).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/TwitterFeed/TwitterFeed.js